
    "use strict";

    var Storages = require('js-storage');

    var $controller = {

        storage: Storages.localStorage,

        dom: window.jQuery,

        selector: '#page',
        el: null,

        delay: 3000,
        delayAfter: 0,

        // TODO: after they've been to the website, the delay should be less and controlled
        // with local storage

        init: function() {

            this.el = this.dom(this.selector);
            if(this.el.length > 0) {
                this.handle();
            }

        },

        handle: function() {

            setTimeout(function() {
                $controller.dom('.tbo-loader').appendTo('body'); // NOTE: force to the end so it can be above everything
            }, 150);
            
            // stupid mobile menu plugin
            // wraps us up

            setTimeout(function() {
                $controller.initialize();
            }, this.getDelay());

        },

        getDelay: function() {
            if (this.storage.get('tbo-loader--initialized')) {
                return this.delayAfter;
            }
            return this.delay;
        },

        initialize: function() {
            this.dom('body').addClass('initialized');
            this.cleanup();
            this.saveState();
        },

        cleanup: function() {
            this.dom('.tbo-loader').remove();
            var $expires = this.storage.get('tbo-loader--initialized');
            if($expires) {
                var $dateExpires = new Date($expires);
                var $date = new Date();
                if (this.diffDays($dateExpires, $date) >= 30) {
                    this.storage.remove('tbo-loader--initialized');
                }
            }
        },

        saveState: function() {
            if (!this.storage.get('tbo-loader--initialized')) {
                this.storage
                    .set('tbo-loader--initialized', (new Date()));
                // NOTE: exires 30 days
            }
        },
        
        // helper functions
        
        diffDays: function (d1, d2) {
            var diff = Math.abs(d1.getTime() - d2.getTime());
            return diff / (1000 * 60 * 60 * 24);
        }

    };

    $controller.init();


// WEBPACK FOOTER //
// ./build/vendor/tbo/js/widget/loader.js